import styled, { css } from 'styled-components';
import { getMediaQuery } from '@magalu/stereo-ui-styles';
const variations = {
  miniature: css`
    margin-top: -25px;
    width: 42px;
    height: 32px;
  `,
  list: css`
    margin-top: -5px;
    width: 50px;
    height: 36px;
  `,
  gallery: css`
    margin-top: -25px;
    width: 55px;
    height: 40px;
    position: absolute;
    ${getMediaQuery('small')} {
      width: 55px;
      height: 40px;
    }
  `,
  productPage: css`
    margin-top: 0px;
    width: 55px;
    height: 40px;
  `
};
export const Wrapper = styled.div`
  position: relative;
  ${({
  displayMode
}) => variations[displayMode] || `margin-top: -25px;`}
`;